import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  CircularProgress,
  Chip,
  Checkbox,
  Typography,
  FormControlLabel,
} from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";

import { motion } from "framer-motion";
import ImageIcon from "@mui/icons-material/Image";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import configServ from "../../services/config";
import Swal from "sweetalert2";
import { pink } from "@mui/material/colors";
import DesktopView from "../../Components/views/DesktopView";
import MobileView from "../../Components/views/MobileView";
import ImageDialog from "./ImageDialog";
import WebcamDialogStudent from "./WebcamDialogStudent";
import LoaderBackdrop from "../Loader/LoaderBackdrop";
import toast from "react-hot-toast";

const Attendance = ({
  handleClose,
  fetchTable,
  editData,
  setEditData,
  isEdit,
  setIsEdit,
}) => {
  const { company_id } = useSelector((state) => state.GlobalVariables);
  const [batch_id, setBatch_id] = useState("");
  const [loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [batch, setBatch] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const [date, setDate] = useState(today);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    // alert("edit")
    const timer = setTimeout(() => {
      setEditData(null); // 3 sec ke baad null
    }, 3000);

    return () => clearTimeout(timer); // cleanup on unmount
  }, []);

  const [remarks, setRemarks] = useState("");
  const [imageBase64, setImageBase64] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewOpenTable, setPreviewOpenTable] = useState(false);

  const [batches, setBatches] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [students, setStudents] = useState([]);
  const [attendanceId, setAttendanceId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const handleBatchChange = (e) => setBatch_id(e.target.value);

  // ✅ Convert selected image to Base64
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImageBase64(reader.result);
      reader.readAsDataURL(file);
    }
  };

  // ✅ Convert selected image to Base64
  const handleImageUploadTable = (e, index) => {
    setSelectedRows([]);
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      const newStudents = [...students];
      newStudents[index].student_image = reader.result;
      setStudents(newStudents);
    };
    reader.readAsDataURL(file);
  };

  // ✅ Handle Save
  const handleSave = async () => {
    try {
      setIsEdit(false);
      setLoading(true);
      const payload = { company_id, batch_id, date, remarks, imageBase64 };

      const result = await configServ.fetchOrCreateAttendance(payload);

      if (result?.status === true) {
        setAttendanceData(result);
        setAttendanceId(result.attendance_id);
        setStudents(result.students || []);
        setImageBase64(result.batch_image || "");
        setRemarks(result.batch_remarks || "");
        fetchTable();
      } else if (result?.status === false ) {
        toast.error(result?.message || "Failed to fetch attendance data");
      } else {
        setAttendanceData([]);
        setAttendanceId(null);
        setStudents([]);
        setImageBase64("");
        setRemarks("");
      }
    } catch (error) {
      console.error("Error fetching students:", error);
      setAttendanceData([]);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Disable future dates
  // const today = new Date().toISOString().split("T")[0];

  // get active batches
  const fetchbatches = async () => {
    try {
      setLoading(true);
      const dataToSend = {
        company_id,
        date,
      };

      const result = await configServ.getActiveBatchesForAttendance(dataToSend);

      if (result?.status === true) {
        setBatches(result.data);
      } else {
        setBatches([]);
      }
    } catch (error) {
      console.error("Error fetching students:", error);
      setBatches([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchbatches();
  }, [date]);

  // ✅ Styles
  const headerCellStyle = {
    fontSize: 14,
    fontWeight: "bold",
    backgroundColor: "#0a75dfff",
    color: "white",
    padding: 8,
    textAlign: "center",
  };
  const cellStyle = { py: 0.5, textAlign: "center" };
  const rowStyle = {
    "&:hover": { background: "#f5faff" },
  };

  const headers = [
    "Registration No",
    "Student Name",
    "Remarks",
    "Photo",
    "Attendance",

    // 👇 Add conditionally
  ];

  // Pagination States
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [filterTerm, setFilterTerm] = useState("");

  // Pagination Handlers
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Filtered Data
  const filteredStudents = students.filter(
    (s) =>
      s.registration_no?.toLowerCase().includes(filterTerm.toLowerCase()) ||
      s.full_name?.toLowerCase().includes(filterTerm.toLowerCase())
  );

  // ✅ Select All / Individual Rows
  const handleSelectAll = () => {
    if (selectedRows.length === filteredStudents.length) {
      setSelectedRows([]);
    } else {
      const allRowIds = filteredStudents.map((row) => ({
        attendance_id: attendanceId,
        id: row.id,
        student_id: row.id,
        student_remarks: row.student_remarks || "",
        student_image: row.student_image || null,
      }));
      setSelectedRows(allRowIds);
    }
  };

  const handleRowCheckboxChange = (row) => {
    const selectedRowId = row.id;
    const selectedStudentId = row.id;

    if (
      selectedRows.some(
        (item) =>
          item.id === selectedRowId && item.student_id === selectedStudentId
      )
    ) {
      setSelectedRows((prev) =>
        prev.filter(
          (item) =>
            !(
              item.id === selectedRowId && item.student_id === selectedStudentId
            )
        )
      );
    } else {
      setSelectedRows((prev) => [
        ...prev,

        {
          id: selectedRowId,
          student_id: selectedStudentId,
          attendance_id: attendanceId,
          student_remarks: row.student_remarks || "",
          student_image: row.student_image || null,
        },
      ]);
    }
  };

  // Step 1: Populate form fields when editData changes
  useEffect(() => {
    if (editData) {
      setDate(editData.date);
      setBatch_id(editData.batch_id);
      setImageBase64(editData.batch_image);
      setRemarks(editData.batch_remarks);
      setStudents([]);
    }
  }, [editData]);

  // Step 2: Trigger handleSave only when date & batch_id are updated
  // useEffect(() => {
  //   if (editData && date && batch_id) {
  //     handleSave();
  //   }
  // }, [editData, date, batch_id]);

  // ✅ Update attendance
  const handleUpdate = async () => {
    if (selectedRows.length === 0) return;

    const { value: selectedStatus, isConfirmed } = await Swal.fire({
      title: "Update Attendance",
      text: "Select status and confirm update:",
      icon: "question",
      input: "select",
      inputOptions: {
        present: "Present",
        absent: "Absent",
        // leave: "Leave",
      },
      inputValue: "present", // ✅ default selected
      showCancelButton: true,
      confirmButtonText: "Yes, Update",
      cancelButtonText: "Cancel",
      inputPlaceholder: "Select Status",
    });

    if (!isConfirmed || !selectedStatus) return;

    try {
      // setLoading(true);

      // ✅ include status in payload
      const payload = {
        status: selectedStatus,
        records: selectedRows,
        company_id,
        batch_id,
        date,
        remarks,
        imageBase64,
        attendance_id: attendanceId,
      };

      console.log("handleUpdate Payload:", payload);

      const res = await configServ.saveAttendanceRecords(payload); //saveAttendanceRecords

      if (res?.status) {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: `Attendance marked as "${selectedStatus}" successfully.`,
          timer: 1500,
          showConfirmButton: false,
        });
        setSelectedRows([]);
        handleClose();
        fetchTable();
      } else {
        Swal.fire(
          "Error",
          res?.message || "Failed to update attendance",
          "error"
        );
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong.", "error");
    } finally {
      // setLoading(false);
    }
  };
  console.log(batch_id, typeof batch_id);
  console.log(students.length);

  const [webcamDialogOpen, setWebcamDialogOpen] = useState(false);
  const [webcamRowIndex, setWebcamRowIndex] = useState(null);
  // const isBatchSelected = batch_id && batch_id !== "ALL";
  return (
    <>
      <LoaderBackdrop open={loading} />
      {/* <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Batch Attendance"}
        isCreate={false}
      /> */}

      {/* Main Form */}
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        style={{ width: "100%", padding: "16px" }}
      >
        <Box
          sx={{
            mt: 3,
            p: 3,
            backgroundColor: "#fff",
            borderRadius: 2,
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            width: "100%",
          }}
        >
          <Grid container spacing={2}>
            {/* Date Picker */}
            <Grid item xs={12} sm={6} md={2.5}>
              <TextField
                label="Select Date"
                type="date"
                size="small"
                fullWidth
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: today }}
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </Grid>
            {/* Batch Dropdown */}
            <Grid item xs={12} sm={3} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Select Batch</InputLabel>
                <Select
                  value={batch_id}
                  onChange={handleBatchChange}
                  label="Select Batch"
                >
                  <MenuItem value="">
                    <em>Select Batch</em>
                  </MenuItem>
                  {batches.map((batch) => (
                    <MenuItem key={batch.id} value={batch.id}>
                      {batch.item_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Remarks */}
            <Grid item xs={12} sm={6} md={5}>
              <TextField
                label="Remarks"
                size="small"
                fullWidth
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </Grid>

            {/* Image Upload + Preview */}
            <Grid item xs={12} sm={6} md={1}>
              <Box display="flex" alignItems="center" gap={1}>
                <IconButton color="primary" onClick={() => setDialogOpen(true)}>
                  <PhotoCameraIcon />
                </IconButton>

                {imageBase64 && (
                  <Box
                    component="img"
                    src={imageBase64}
                    alt="Preview"
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      cursor: "pointer",
                      objectFit: "cover",
                      border: "1px solid #ccc",
                    }}
                    onClick={() => setDialogOpen(true)}
                  />
                )}
              </Box>

              <ImageDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                imageBase64={imageBase64}
                setImageBase64={setImageBase64}
              />
            </Grid>

            {/* Save Button (Full Width on Mobile, Right-Aligned on Desktop) */}
            <Grid container spacing={2} justifyContent="flex-end" mt={1}>
              {students.length > 0 && (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      backgroundColor: "#ffe6e6",
                      border: "1px solid #ff4d4d",
                      color: "#b30000",
                      borderRadius: 2,
                      p: 1.2,
                      mb: 1,
                      textAlign: "center",
                      fontWeight: 500,
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                    }}
                  >
                    ⚠️ Please update at least one student attendance before
                    Closing this windows.
                  </Box>
                </Grid>
              )}
              {/* Save Button */}
              <Grid item xs={12} sm="auto">
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  sx={{
                    textTransform: "none",
                    borderRadius: 2,
                    px: 3,
                    fontWeight: 500,
                    width: { xs: "100%", sm: "auto" },
                  }}
                  onClick={handleSave}
                  disabled={!batch_id || students.length > 0}
                >
                  {isEdit
                    ? "Click Here"
                    : students.length > 0
                    ? "Save"
                    : "Generate Attendance"}
                </Button>
              </Grid>

              {/* Update Button */}
              {selectedRows.length > 0 && (
                <Grid item xs={12} sm="auto">
                  <Button
                    variant="contained"
                    color="secondary"
                    size="medium"
                    sx={{
                      textTransform: "none",
                      borderRadius: 2,
                      px: 3,
                      fontWeight: 500,
                      width: { xs: "100%", sm: "auto" },
                    }}
                    onClick={handleUpdate}
                  >
                    Mark Attendance ({selectedRows.length})
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Box>
      </motion.div>

      {/* ✅ Image Preview Dialog */}
      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        fullWidth
        maxWidth="sm"
        PaperComponent={motion.div}
        PaperProps={{
          initial: { opacity: 0, scale: 0.95 },
          animate: { opacity: 1, scale: 1 },
          exit: { opacity: 0, scale: 0.9 },
          transition: { duration: 0.3 },
          style: { borderRadius: 16, backgroundColor: "#fff" },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 600,
            color: "#1976d2",
            borderBottom: "1px solid #eee",
            position: "relative", // ✅ make it relative for absolute button
          }}
        >
          Image Preview
          {/* ✅ Close button */}
          <IconButton
            aria-label="close"
            onClick={() => setPreviewOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "#555",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 3,
          }}
        >
          <motion.img
            src={imageBase64}
            alt="Preview"
            initial={{ scale: 0.95 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.3 }}
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              borderRadius: 8,
              boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
            }}
          />
        </DialogContent>
      </Dialog>

      {/* ✅ Image Table Image  Preview Dialog */}
      <Dialog
        open={previewOpenTable}
        onClose={() => setPreviewOpenTable(false)}
        fullWidth
        maxWidth="sm"
        PaperComponent={motion.div}
        PaperProps={{
          initial: { opacity: 0, scale: 0.95 },
          animate: { opacity: 1, scale: 1 },
          exit: { opacity: 0, scale: 0.9 },
          transition: { duration: 0.3 },
          style: { borderRadius: 16, backgroundColor: "#fff" },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 600,
            color: "#1976d2",
            borderBottom: "1px solid #eee",
            position: "relative", // ✅ make it relative for absolute button
          }}
        >
          Image Preview
          {/* ✅ Close button */}
          <IconButton
            aria-label="close"
            onClick={() => setPreviewOpenTable(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "#555",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 3,
          }}
        >
          <motion.img
            src={previewImage}
            alt="Preview"
            initial={{ scale: 0.95 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.3 }}
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              borderRadius: 8,
              boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
            }}
          />
        </DialogContent>
      </Dialog>

      <WebcamDialogStudent
        open={webcamDialogOpen}
        imageBase64={students[webcamRowIndex]?.student_image || null}
        onClose={() => setWebcamDialogOpen(false)}
        onSave={(base64) => {
          const newStudents = [...students];
          const studentId = newStudents[webcamRowIndex].id;

          // 1️⃣ Update student image in students array
          newStudents[webcamRowIndex].student_image = base64;
          setStudents(newStudents);

          // 2️⃣ Update selectedRows if already selected, else add it
          setSelectedRows((prev) => {
            const existingIndex = prev.findIndex(
              (item) => item.student_id === studentId
            );

            if (existingIndex !== -1) {
              // Update existing
              const updated = [...prev];
              updated[existingIndex] = {
                ...updated[existingIndex],
                student_image: base64,
              };
              return updated;
            } else {
              // Add new to selectedRows
              return [
                ...prev,
                {
                  attendance_id: attendanceId,
                  id: studentId,
                  student_id: studentId,
                  student_remarks:
                    newStudents[webcamRowIndex].student_remarks || "",
                  student_image: base64,
                },
              ];
            }
          });

          // 3️⃣ Close dialog
          setWebcamDialogOpen(false);
        }}
      />

      {/* Table Section */}
      {students.length > 0 && (
        <DesktopView>
          <TableContainer component={Paper} sx={{ px: 1 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={headerCellStyle}>
                    <Checkbox
                      checked={
                        selectedRows.length === filteredStudents.length &&
                        filteredStudents.length > 0
                      }
                      onChange={handleSelectAll}
                      sx={{
                        color: pink[800],
                        "&.Mui-checked": {
                          color: pink[600],
                        },
                      }}
                      // color="success"
                    />
                  </TableCell>
                  {/* <TableCell style={headerCellStyle}>Sr. No.</TableCell> */}
                  {headers.map((header, index) => (
                    <TableCell key={index} style={headerCellStyle}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={headers.length + 2} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : students.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={headers.length + 2}
                      align="center"
                      sx={{ color: "red" }}
                    >
                      <b>Please select Date and Batch.</b>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredStudents
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, rowIndex) => (
                      <TableRow key={row.id} sx={rowStyle}>
                        <TableCell sx={cellStyle}>
                          <Checkbox
                            checked={selectedRows.some(
                              (item) => item.id === row.id
                            )}
                            onChange={() => handleRowCheckboxChange(row)}
                          />
                        </TableCell>
                        {/* <TableCell sx={cellStyle}>
                        {page * rowsPerPage + rowIndex + 1}
                      </TableCell> */}

                        <TableCell sx={cellStyle}>
                          {row.registration_no || "—"}
                        </TableCell>
                        <TableCell sx={cellStyle}>
                          {row.full_name || "—"}
                        </TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            value={row.student_remarks || ""}
                            onChange={(e) => {
                              const newData = [...students];
                              newData[rowIndex].student_remarks =
                                e.target.value;
                              setStudents(newData);

                              // 🔁 Update selectedRows if this row is already selected
                              setSelectedRows((prev) =>
                                prev.map((item) =>
                                  item.student_id === row.id
                                    ? {
                                        ...item,
                                        student_remarks: e.target.value,
                                      }
                                    : item
                                )
                              );
                            }}
                          />
                        </TableCell>
                        <TableCell sx={cellStyle}>
                          {students[rowIndex]?.photo_url ? (
                            <Box
                              component="img"
                              src={students[rowIndex].photo_url}
                              alt={students[rowIndex].full_name}
                              sx={{
                                width: 40,
                                height: 40,
                                borderRadius: "50%",
                                cursor: "pointer",
                                objectFit: "cover",
                                border: "1px solid #ccc",
                              }}
                              onClick={() => {
                                setPreviewImage(students[rowIndex].photo_url);
                                setPreviewOpenTable(true);
                              }}
                            />
                          ) : (
                            <CloseIcon
                              sx={{
                                width: 40,
                                height: 40,
                                color: "red",
                                borderRadius: "50%",
                                border: "1px solid #ccc",
                                padding: "8px",
                                backgroundColor: "#f9f9f9",
                              }}
                            />
                          )}
                        </TableCell>

                        {/* <TableCell sx={cellStyle}>
                        {!row.status ? (
                          <Chip
                            label="Absent"
                            color="error"
                            size="small"
                            sx={{ fontWeight: 500 }}
                          />
                        ) : (
                          <Chip
                            label={row.status || "Not marked"}
                            color={
                              row.status === "present" ? "success" : "error"
                            }
                            size="small"
                            sx={{ fontWeight: 500 }}
                          />
                        )}
                      </TableCell> */}
                        <TableCell>
                          <Box display="flex" alignItems="center" gap={1}>
                            {/* 📸 Camera Icon */}
                            <IconButton
                              color="primary"
                              onClick={() => {
                                setWebcamRowIndex(rowIndex);
                                setWebcamDialogOpen(true);
                              }}
                            >
                              <PhotoCameraIcon />
                            </IconButton>

                            {/* 🖼️ Student Image (if available) */}
                            {students[rowIndex]?.student_image && (
                              <Box
                                component="img"
                                src={students[rowIndex].student_image}
                                alt={students[rowIndex].full_name}
                                sx={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: "50%",
                                  cursor: "pointer",
                                  objectFit: "cover",
                                  border: "1px solid #ccc",
                                }}
                                onClick={() => {
                                  setPreviewImage(
                                    students[rowIndex].student_image
                                  );
                                  setPreviewOpenTable(true);
                                }}
                              />
                            )}

                            {/* ✅ Attendance Emoji */}
                            <Box
                              sx={{
                                fontSize: 20,
                                ml: 1,
                              }}
                            >
                              {row.status === "present" ? "✔️" : "❌"}
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={filteredStudents.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 100, 150, 200]}
            />
          </TableContainer>
        </DesktopView>
      )}

      {/* Mobile view */}

      {students.length > 0 && (
        <MobileView>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "10px",
            }}
          >
            <FormControlLabel
              label="Select All"
              control={
                <Checkbox
                  checked={
                    selectedRows.length === filteredStudents.length &&
                    filteredStudents.length > 0
                  }
                  onChange={handleSelectAll}
                  sx={{
                    color: pink[800],
                    "&.Mui-checked": {
                      color: pink[600],
                    },
                  }}
                />
              }
            />
          </div>

          <Grid container spacing={2}>
            {filteredStudents
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, rowIndex) => (
                <Grid item xs={12} key={row.id}>
                  <motion.div
                    whileHover={{ scale: 1.01 }}
                    transition={{ duration: 0.2 }}
                    style={{
                      background: "#fff",
                      borderRadius: 12,
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                      padding: "12px 16px",
                    }}
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mb={1}
                    >
                      <Typography variant="subtitle1" fontWeight={600}>
                        {row.full_name || "—"}
                      </Typography>
                      <Checkbox
                        checked={selectedRows.some(
                          (item) => item.id === row.id
                        )}
                        onChange={() => handleRowCheckboxChange(row)}
                      />
                    </Box>

                    <Typography variant="body2" color="text.secondary">
                      <b>Reg. No:</b> {row.registration_no || "—"}
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                      <b>Photo:</b>{" "}
                      {students[rowIndex]?.photo_url ? (
                        <Box
                          component="img"
                          src={students[rowIndex].photo_url}
                          alt={students[rowIndex].full_name}
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            cursor: "pointer",
                            objectFit: "cover",
                            border: "1px solid #ccc",
                          }}
                          onClick={() => {
                            setPreviewImage(students[rowIndex].photo_url);
                            setPreviewOpenTable(true);
                          }}
                        />
                      ) : (
                        <CloseIcon
                          sx={{
                            width: 40,
                            height: 40,
                            color: "red",
                            borderRadius: "50%",
                            border: "1px solid #ccc",
                            padding: "8px",
                            backgroundColor: "#f9f9f9",
                          }}
                        />
                      )}
                    </Typography>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 0.5 }}
                    >
                      <b>Attendance:</b>{" "}
                      {row.status ? (
                        <Chip
                          label={row.status}
                          color="success"
                          size="small"
                          sx={{ ml: 1, fontWeight: 500 }}
                        />
                      ) : (
                        <Chip
                          label="Absent"
                          color="error"
                          size="small"
                          sx={{ ml: 1, fontWeight: 500 }}
                        />
                      )}
                    </Typography>

                    {/* Remarks Input */}
                    <Box mt={1.2}>
                      <TextField
                        size="small"
                        value={row.student_remarks || ""}
                        onChange={(e) => {
                          const newData = [...students];
                          newData[rowIndex].student_remarks = e.target.value;
                          setStudents(newData);

                          // 🔁 Update selectedRows if this row is already selected
                          setSelectedRows((prev) =>
                            prev.map((item) =>
                              item.student_id === row.id
                                ? { ...item, student_remarks: e.target.value }
                                : item
                            )
                          );
                        }}
                      />
                    </Box>

                    {/* Upload + Preview */}
                    <Box display="flex" alignItems="center" gap={1} mt={1.5}>
                      {/* 📷 Webcam Button */}
                      <IconButton
                        color="primary"
                        onClick={() => {
                          setWebcamRowIndex(rowIndex);
                          setWebcamDialogOpen(true);
                        }}
                      >
                        <PhotoCameraIcon />
                      </IconButton>

                      {/* 🖼️ Preview Button */}
                      {students[rowIndex]?.student_image && (
                        <Box
                          component="img"
                          src={students[rowIndex].student_image}
                          alt={students[rowIndex].full_name}
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            cursor: "pointer",
                            objectFit: "cover",
                            border: "1px solid #ccc",
                          }}
                          onClick={() => {
                            setPreviewImage(students[rowIndex].student_image);
                            setPreviewOpenTable(true);
                          }}
                        />
                      )}
                    </Box>
                  </motion.div>
                </Grid>
              ))}
            {/* Pagination for Mobile */}
            <Grid item xs={12} display="flex" justifyContent="center" mt={2}>
              <TablePagination
                component="div"
                count={filteredStudents.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 100, 150, 200]}
              />
            </Grid>
          </Grid>
        </MobileView>
      )}
    </>
  );
};

export default Attendance;
